export const funnelsChartSteps = [
  {
    title: `Event 1`,
    subheader: `Subheader text`,
    data: [
      {
        value: 242,
        conversionToNext: 0.9173,
      },
    ],
    tooltipText: `Event 1 w/ some filters applied`,
  },
  {
    title: `Event 2`,
    subheader: null,
    data: [
      {
        value: 222,
        conversionToNext: 0.8063,
      },
    ],
    tooltipText: `Event 2`,
  },
  {
    title: `Event 3`,
    subheader: null,
    data: [
      {
        value: 179,
        conversionToNext: 0.8938,
      },
    ],
    tooltipText: null,
  },
  {
    title: `Event 4`,
    subheader: null,
    data: [
      {
        value: 160,
        conversionToNext: 0.8,
      },
    ],
  },
  {
    title: `Event 5`,
    subheader: null,
    data: [
      {
        value: 128,
        conversionToNext: 0.7578,
      },
    ],
  },
  {
    title: `Event 6`,
    subheader: `Filters by x property`,
    data: [
      {
        value: 97,
        conversionToNext: 0.6391,
      },
    ],
  },
  {
    title: `Event 7`,
    subheader: null,
    data: [
      {
        value: 62,
        conversionToNext: 0.3225,
      },
    ],
  },
  {
    title: `Event 8`,
    data: [
      {
        value: 20,
      },
    ],
  },
];
